<div class="media-container">
    <video *ngIf="videoDisplay" id="video" [muted]="'muted'" autoplay width="100%" height="100%"
        (ended)="playNextMedia()">
        <source [src]="sourceUrl">
    </video>
    <img *ngIf="imageDisplay" [src]="sourceUrl" id="image" width="100%" height="100%" />
</div>